import { buildFullName } from 'src/lib/formatters'

import { defaultVoECompletionPlatform } from './VoECompletionFields'
import type { VoECompletionSubject } from './VoECompletionFields'

export interface VoECompletionSource extends VoECompletionSubject {
  companyName?: string | null
  driverName?: string | null
  platform?: string | null
  carrierRouting?: { preferredPlatform?: string | null } | null
  applicant?: {
    firstName?: string | null
    middleName?: string | null
    lastName?: string | null
  } | null
}

/** The completion modal props that describe one verification. */
export const voeCompletionContext = (
  voe: VoECompletionSource | null | undefined
) => ({
  applicantName: buildFullName(voe?.applicant) ?? voe?.driverName ?? null,
  companyName: voe?.companyName ?? null,
  subject: voe
    ? {
        contactName: voe.contactName,
        email: voe.email,
        phoneNumber: voe.phoneNumber,
        faxNumber: voe.faxNumber,
        dotNumber: voe.dotNumber,
      }
    : null,
  defaultPlatform: defaultVoECompletionPlatform(voe),
})

export const toMarkVoEAsCompletedInput = (values: {
  completionMethod: string
  platform: string | null
  contact?: Record<string, string | undefined> | null
  dotNumber?: string | null
  note?: string | null
}) => ({
  completionMethod: values.completionMethod,
  platform: values.platform,
  contact: values.contact ?? null,
  dotNumber: values.dotNumber ?? null,
  note: values.note ?? null,
})
